module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/village//result-top_bg.png?v=3736d7e9";